module.exports = __webpack_public_path__ + "b62ee72552f2e381189681a15f463edf.png";